import * as React from "react";
import { Check, Copy } from "lucide-react";
import { cn } from "../lib/utils";
import { Button } from "./button";

interface CopyButtonProps {
  value: string;
  className?: string;
  size?: "sm" | "icon";
}

export function CopyButton({ value, className, size = "icon" }: CopyButtonProps) {
  const [copied, setCopied] = React.useState(false);

  async function copy() {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Button
      variant="ghost"
      size={size === "icon" ? "icon" : "sm"}
      className={cn("h-7 w-7 text-muted-foreground hover:text-foreground", className)}
      onClick={copy}
      title="Copy to clipboard"
    >
      {copied ? (
        <Check className="h-3.5 w-3.5 text-success" />
      ) : (
        <Copy className="h-3.5 w-3.5" />
      )}
      <span className="sr-only">Copy</span>
    </Button>
  );
}
